import React, { useState, useEffect } from 'react';
import PurchaseOrdersList from './PurchaseOrdersList';
import ViewPurchaseOrder from './ViewPurchaseOrder';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './PurchaseOrders.css';

function PurchaseOrders() {
  const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // 'list', 'view', 'edit', 'create'

  useEffect(() => {
    // Set toolbar based on current mode
    if (window.setToolbar) {
      if (viewMode === 'list') {
        window.setToolbar({
          title: 'Purchase Orders',
          buttons: [
            {
              label: 'New Purchase Order',
              icon: '➕',
              onClick: handleNew,
              variant: 'primary'
            },
            {
              label: 'Refresh',
              icon: '🔄',
              onClick: handleRefresh
            }
          ]
        });
      } else if (viewMode === 'view') {
        window.setToolbar({
          title: 'View Purchase Order',
          showBack: true,
          onBack: handleBack,
          buttons: [
            {
              label: 'Edit',
              icon: '✏️',
              onClick: handleEdit,
              variant: 'secondary'
            },
            {
              label: 'Delete',
              icon: '🗑️',
              onClick: handleDelete,
              variant: 'danger'
            }
          ]
        });
      } else if (viewMode === 'edit') {
        window.setToolbar({
          title: 'Edit Purchase Order',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Save',
              icon: '💾',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      } else if (viewMode === 'create') {
        window.setToolbar({
          title: 'New Purchase Order',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Create',
              icon: '➕',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      }
    }

    return () => {
      if (window.setToolbar) {
        window.setToolbar(null);
      }
    };
  }, [viewMode]);

  const handleSelectPurchaseOrder = (purchaseOrderId) => {
    setSelectedPurchaseOrderId(purchaseOrderId);
    setViewMode('view');
  };

  const handleNew = () => {
    setSelectedPurchaseOrderId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleDelete = () => {
    // Delete will be handled in ViewPurchaseOrder component
    if (window.viewPurchaseOrderRef && window.viewPurchaseOrderRef.handleDelete) {
      window.viewPurchaseOrderRef.handleDelete();
    }
  };

  const handleSave = () => {
    // Save will be handled in ViewPurchaseOrder component
    if (window.viewPurchaseOrderRef && window.viewPurchaseOrderRef.handleSave) {
      window.viewPurchaseOrderRef.handleSave();
    }
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedPurchaseOrderId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleBack = () => {
    setViewMode('list');
    setSelectedPurchaseOrderId(null);
  };

  const handleRefresh = () => {
    // Trigger refresh in PurchaseOrdersList
    if (window.purchaseOrdersListRef && window.purchaseOrdersListRef.fetchPurchaseOrders) {
      window.purchaseOrdersListRef.fetchPurchaseOrders();
    }
  };

  const handlePurchaseOrderSaved = (purchaseOrder) => {
    setSelectedPurchaseOrderId(purchaseOrder.po_id);
    setViewMode('view');
    // Refresh the list
    if (window.purchaseOrdersListRef && window.purchaseOrdersListRef.fetchPurchaseOrders) {
      window.purchaseOrdersListRef.fetchPurchaseOrders();
    }
  };

  return (
    <div className="purchase-orders-page">
      <ResizablePanels
        leftPanel={
          <PurchaseOrdersList
            ref={ref => window.purchaseOrdersListRef = ref}
            onSelectPurchaseOrder={handleSelectPurchaseOrder}
            selectedPurchaseOrderId={selectedPurchaseOrderId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewPurchaseOrder
              ref={ref => window.viewPurchaseOrderRef = ref}
              purchaseOrderId={selectedPurchaseOrderId}
              onBack={handleBack}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onSave={handlePurchaseOrderSaved}
              onCancel={handleCancel}
              onEdit={handleEdit}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
}

export default PurchaseOrders;